<template>

	<dashboard-plugin
			class="admin-dashboard-plugins-ResponseTime"
			name="Acceptatietijden"
			:loading="loading"
			:loadedFirstTime="loadedFirstTime"
			:hasData="hasData"
		>

		<h5 class="mb-1">Gemiddelde acceptatietijd</h5>
		<small class="block text-muted">De gemiddelde tijd in seconden tussen de oproep en het accepteren van die oproep, gemeten over de geselecteerde periode.</small>

		<gauge
			ref="gauge"
			class="mt-1 -mb-10"

			:rangeLabels="[0, 360]"
			:arcLabels="[60, 240]"
			:amount="responseTimeAmount"
			:centerLabel="responseTimeAmountCenterLabel"
		/>

		<h5 class="mb-1">Langste acceptatietijden</h5>
		<small class="block mb-5 text-muted">De top 5 van de langste acceptatietijden, gemeten over de geselecteerde periode.</small>

		<grid
			ref="grid"
			:columns="gridColumns"
			:rows="gridRows"
		/>

	</dashboard-plugin>

</template>

<script>

import DashboardPlugin from "./common/DashboardPlugin";
import Gauge from "./common/Gauge";
import Api from "../api";
import Grid from "./common/Grid";

import {filterStore} from "../filterStore";
import loader from "./mixins/loader";

export default {
	name: 'response-time-gauge',
	mixins: [loader],
	components: {
		DashboardPlugin,
		Gauge,
		Grid,
	},

	data: () => {
		return {
			responseTime: null,
			gridColumns: [
				{
					property: 'created_at',
					title: 'Datum',
					direction: null,
					filterable: true,
				},
				{
					property: 'accepted_duration',
					title: 'Acceptatietijd',
					direction: null,
					filterable: true,
				},
			],
			gridRows: null,
		};
	},

	methods: {

		updateHandler()
		{
			this.updateGauge();
			this.updateGrid();
		},

		async updateGauge()
		{
			this.incrementLoading()

			// Load the mean response time for the notifications
			this.responseTime = await Api.getNotificationMeanResponseTime()

			this.decrementLoading()
		},

		async updateGrid()
		{
			this.incrementLoading()

			// Needed to set our
			let table = this?.$refs?.grid?.$refs?.table?.$refs.table;

			// Get the employees with their corresponding score. These are used to display in the grid
			this.gridRows = await Api.getNotificationsAcceptedDurationSpikes();

			if(table) {
				this.$nextTick(() => {
					table.totalFilteredRowsChanged(table.filteredRows.length)
				})
			}

			this.decrementLoading()
		},


	},

	computed: {

		filterStore: () => filterStore,

		responseTimeAmountCenterLabel()
		{
			return ' ' + Math.round(this.responseTimeAmount) + 's';
		},

		// Stores the mean response time for a notification (in seconds)
		responseTimeAmount()
		{
			return Number(this.responseTime)
		},

		hasData()
		{
			return this.responseTime != "" && this.gridRows != null;
		},

	},
}
</script>

<style lang="scss">

	.admin-dashboard-plugins-ResponseTime .admin-dashboard-plugins-common-Grid {

		.vue-ads-flex.vue-ads-py-3 {
			display: none;
		}

		th:not(:first-child) {
			width: 150px;
		}

	}

</style>
